<template>
    <div class="group-item-group vehicle-group">
        <div @click.stop="handleSelect" class="check-container"
             title="En cochant ce groupe, tous ses véhicules, y compris les véhicules ajoutés à l'avenir seront exportés">
            <font-awesome-icon icon="check" v-if="selected"></font-awesome-icon>
        </div>
        <span>
            {{ group.name }}
            <span class="badge" v-if="nbSelectedItems > 0">{{ nbSelectedItems }}</span>
        </span>
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            selected() {
                return this.group.selected
            }
        },
        created: function () {

        },
        data() {
            return {
                //selected: false
            }
        },
        destroyed: function () {

        },
        methods: {
            handleSelect() {
                //this.selected = !this.selected
                this.$emit('selected', this.group, !this.selected)
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            group: {
                type: Object,
                required: true
            },
            nbSelectedItems: {
                type: Number,
                default: 0
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .vehicle-group {

        display: flex;
        align-items: center;
        border-bottom: solid $form-elements-border-size $main-color;
        border-right: solid ($form-elements-border-size * 1.5) $secondary-color;
        padding: 10px;
        transition: border 200ms ease-out;

        &:last-child {
            border-bottom: none;
        }

        .check-container {
            background-color: $main-white;
            width: 30px;
            height: 30px;
            align-items: center;
            border: solid 1px $main-color;
            border-radius: 4px;
            cursor: pointer;
            flex: 0 0 30px;
            margin-right: 5px;
            justify-content: center;
            display: flex;

            svg {
                color: $main-color;
                /*transition-property: color;
                color: rgba(desaturate($main-color,50%),0);*/
            }
        }

        span {
            flex: 1 1 100%;


        }

        .badge{
            padding: 1px 5px;
            font-weight: $bold;
            vertical-align: middle;
        }

        & > .svg-inline--fa {
            flex: 0 0 30px;
            cursor: pointer;
            transition: margin 300ms ease-out;
        }

        &:hover {
            background-color: lighten($main-color, 45%);
        }

        &.active {
            background-color: lighten($main-color, 25%);
            border-right: solid ($form-elements-border-size * 1.5) lighten($main-color, 25%);

            & > .svg-inline--fa {
                margin-left: 10px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/renderers/groupItem/VehicleGroup.vue